<script setup>
import { useUserStore } from '@/stores/user'
import { onMounted } from 'vue'
import PageToolbar from '@/components/common/PageToolbar.vue'
import ToolbarHeading from '@/components/common/ToolbarHeading.vue'

const userStore = useUserStore()

onMounted(async () => {
  await userStore.details()
})
</script>

<template>
  <div class="account-page">
    <div class="page-container">
      <PageToolbar>
        <ToolbarHeading title="Account" />
        <div class="header-tabs">
          <router-link
            to="/account"
            class="tab-btn"
            exact-active-class="active"
          >
            <font-awesome-icon :icon="['fas', 'circle-user']" />
            Information
          </router-link>
          <router-link
            to="/account/apikeys"
            class="tab-btn"
            active-class="active"
          >
            <font-awesome-icon :icon="['fas', 'key']" />
            API Keys
          </router-link>
        </div>
      </PageToolbar>

      <div class="router-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Full-bleed page: content flows naturally and #main-scroll-container scrolls
   (it supplies `padding: 1rem 1rem 1rem 0`, so we keep left padding at 0 to
   align flush with the sidebar). */
.account-page {
  background: var(--surface-page);
}

.page-container {
  width: 100%;
  padding: 0 0 2rem 0;
}

/* Gap between the toolbar row and the child view, matching Signals/SavedSearches.
   .page-header is the root rendered by <PageToolbar/>. */
:deep(.page-header) {
  margin-bottom: 1rem;
}

/* router-link tabs need their default anchor underline reset. */
:deep(.tab-btn) {
  text-decoration: none;
}
</style>
